/** Базовые строки: навигация, общие, профиль / синхронизация, дашборды. */
export const CORE_RU = {
  'common.save': 'Сохранить',
  'common.saving': 'Сохранение…',
  'common.cancel': 'Отмена',
  'common.close': 'Закрыть',
  'common.delete': 'Удалить',
  'common.edit': 'Изменить',
  'common.add': 'Добавить',
  'common.loading': 'Загрузка…',
  'common.error': 'Ошибка',
  'common.success': 'Готово',
  'common.continue': 'Продолжить',
  'common.profile': 'Профиль',
  'common.client': 'Клиент',
  'common.optional': 'необязательно',
  'common.required': 'обязательно',
  'common.retry': 'Попробовать снова',
  'common.exit': 'Выйти',
  'common.reload': 'Обновить',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.kg': 'кг',

  'nav.home': 'Главная',
  'nav.clients': 'Клиенты',
  'nav.plans': 'Планы',
  'nav.analytics': 'Аналитика',
  'nav.exercises': 'Упражнения',
  'nav.profile': 'Профиль',
  'nav.profileMenu': 'Меню профиля',

  'dash.logout': 'Выйти из аккаунта',
  'dash.logoutConfirmTitle': 'Выйти из аккаунта?',
  'dash.logoutConfirmDesc': 'Вы уверены, что хотите выйти?',
  'dash.switchToTrainer': 'Переключиться на тренера',
  'dash.switchToClient': 'Переключиться на клиента',
  'dash.calendarWeek': 'Недельный вид',
  'dash.calendarBackToList': 'Вернуться к списку',
  'dash.refresh': 'Обновить',
  'dash.refreshAria': 'Обновить данные',

  'app.offlineSaved':
    'Сохранено офлайн. Отправим на сервер при появлении сети.',
  'app.telegramLoginFailed': 'Не удалось войти через Telegram.',
  'app.telegramLoginHint':
    'Обновите окно или войдите по email — так же, как на обычном сайте.',
  'app.refresh': 'Обновить',
  'app.loginWithEmail': 'Войти по email',
  'app.loadContext': 'Загрузка контекста пользователя…',
  'app.loadInterface': 'Загрузка интерфейса…',
  'app.initializing': 'Загрузка…',
  'app.contextError.default':
    'Не удалось загрузить данные. Проверьте соединение и попробуйте снова.',
  'app.contextError.timeout':
    'Сервер не ответил вовремя. Проверьте сеть и попробуйте снова.',
  'app.contextError.server':
    'Сервер временно недоступен. Попробуйте позже.',
  'app.contextError.client':
    'Не удалось загрузить профиль. Попробуйте ещё раз.',
  'app.noRole':
    'Для аккаунта не настроена роль тренера или клиента. Обратитесь в поддержку.',
  'app.google.invalid_state': 'Сессия устарела. Попробуйте войти снова.',
  'app.google.email_not_verified': 'Подтвердите email в Google.',
  'app.google.account_conflict': 'Аккаунт уже привязан к другому Google.',
  'app.google.not_configured': 'Вход через Google отключён на сервере.',
  'app.google.server_error': 'Ошибка сервера. Попробуйте позже.',
  'app.google.user_create_failed': 'Не удалось создать аккаунт.',
  'app.telegram.http': 'Сервер ответил {status}',
  'app.telegram.genericFail': 'Не удалось войти через Telegram',
  'app.telegram.http': 'Сервер ответил {status}',
  'app.telegram.network': 'Нет сети или запрос заблокирован (CORS)',
  'app.google.unknown': 'Ошибка входа через Google ({reason})',

  'profile.languageTitle': 'Язык интерфейса',
  'profile.lang.ru': 'Русский',
  'profile.lang.en': 'English',
  'profile.lang.es': 'Español',
  'profile.syncTitle': 'Синхронизировать данные',
  'profile.syncTabGive': 'Показать код',
  'profile.syncTabTake': 'Ввести код',
  'profile.syncGiveIntro':
    'На другом устройстве откройте вкладку «Ввести код». Введите ID аккаунта и код на другом устройстве.',
  'profile.syncAccountId': 'ID аккаунта',
  'profile.syncCodeLabel': 'Код для синхронизации',
  'profile.syncCopyId': 'Копировать ID',
  'profile.syncCopyCode': 'Копировать код',
  'profile.syncGenerate': 'Сгенерировать код',
  'profile.syncTakeIntro':
    'Вставьте значения с экрана «Показать код» на другом устройстве.',
  'profile.syncPlaceholderId': 'Введите ID аккаунта',
  'profile.syncPlaceholderCode': '000000',
  'profile.syncVerifying': 'Проверяем…',
  'profile.mergeTitle': 'Объединение аккаунтов',
  'profile.mergeChoosePrimary': 'Выберите, какой аккаунт оставить основным',
  'profile.mergeCombineData':
    'Объединить информацию о тренировках, клиентах и оплатах',
  'profile.mergeConfirm': 'Подтвердить',
  'profile.mergeCancel': 'Отмена',
};

export const CORE_EN = {
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.loading': 'Loading…',
  'common.error': 'Error',
  'common.success': 'Done',
  'common.continue': 'Continue',
  'common.profile': 'Profile',
  'common.client': 'Client',
  'common.optional': 'optional',
  'common.required': 'required',
  'common.retry': 'Try again',
  'common.exit': 'Log out',
  'common.reload': 'Reload',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.kg': 'kg',

  'nav.home': 'Home',
  'nav.clients': 'Clients',
  'nav.plans': 'Plans',
  'nav.analytics': 'Analytics',
  'nav.exercises': 'Exercises',
  'nav.profile': 'Profile',
  'nav.profileMenu': 'Profile menu',

  'dash.logout': 'Log out',
  'dash.logoutConfirmTitle': 'Log out?',
  'dash.logoutConfirmDesc': 'Are you sure you want to log out?',
  'dash.switchToTrainer': 'Switch to trainer',
  'dash.switchToClient': 'Switch to client',
  'dash.calendarWeek': 'Week view',
  'dash.calendarBackToList': 'Back to list',
  'dash.refresh': 'Refresh',
  'dash.refreshAria': 'Refresh data',

  'app.offlineSaved': 'Saved offline. We’ll sync when you’re back online.',
  'app.telegramLoginFailed': 'Couldn’t sign in with Telegram.',
  'app.telegramLoginHint':
    'Reload the page or sign in with email — same as on the website.',
  'app.refresh': 'Reload',
  'app.loginWithEmail': 'Sign in with email',
  'app.loadContext': 'Loading your account…',
  'app.loadInterface': 'Loading the app…',
  'app.initializing': 'Loading…',
  'app.contextError.default':
    'Couldn’t load your data. Check your connection and try again.',
  'app.contextError.timeout': 'The server took too long. Check your network and try again.',
  'app.contextError.server': 'The server is temporarily unavailable. Try again later.',
  'app.contextError.client': 'Couldn’t load your profile. Please try again.',
  'app.noRole':
    'No trainer or client role is set for this account. Please contact support.',
  'app.google.invalid_state': 'Your session expired. Please sign in again.',
  'app.google.email_not_verified': 'Verify your email with Google.',
  'app.google.account_conflict': 'This account is already linked to another Google user.',
  'app.google.not_configured': 'Google sign-in is disabled on the server.',
  'app.google.server_error': 'Server error. Try again later.',
  'app.google.user_create_failed': 'Couldn’t create the account.',
  'app.telegram.http': 'Server responded with {status}',
  'app.telegram.genericFail': 'Couldn’t sign in with Telegram',
  'app.telegram.http': 'Server returned {status}',
  'app.telegram.network': 'No network or request blocked (CORS)',
  'app.google.unknown': 'Google sign-in error ({reason})',

  'profile.languageTitle': 'Interface language',
  'profile.lang.ru': 'Russian',
  'profile.lang.en': 'English',
  'profile.lang.es': 'Español',
  'profile.syncTitle': 'Sync your account',
  'profile.syncTabGive': 'Show code',
  'profile.syncTabTake': 'Enter code',
  'profile.syncGiveIntro':
    'On your other device, open “Enter code” and type this account ID and sync code.',
  'profile.syncAccountId': 'Account ID',
  'profile.syncCodeLabel': 'Sync code',
  'profile.syncCopyId': 'Copy ID',
  'profile.syncCopyCode': 'Copy code',
  'profile.syncGenerate': 'Generate code',
  'profile.syncTakeIntro':
    'Paste the values from “Show code” on your other device.',
  'profile.syncPlaceholderId': 'Enter account ID',
  'profile.syncPlaceholderCode': '000000',
  'profile.syncVerifying': 'Checking…',
  'profile.mergeTitle': 'Merge accounts',
  'profile.mergeChoosePrimary': 'Choose which account stays primary',
  'profile.mergeCombineData':
    'Merge workouts, clients, and payment history',
  'profile.mergeConfirm': 'Confirm',
  'profile.mergeCancel': 'Cancel',
};

/** Español — texto natural (español general, comprensible en Latinoamérica y España). */
export const CORE_ES = {
  'common.save': 'Guardar',
  'common.saving': 'Guardando…',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.add': 'Añadir',
  'common.loading': 'Cargando…',
  'common.error': 'Error',
  'common.success': 'Listo',
  'common.continue': 'Continuar',
  'common.profile': 'Perfil',
  'common.client': 'Cliente',
  'common.optional': 'opcional',
  'common.required': 'obligatorio',
  'common.retry': 'Reintentar',
  'common.exit': 'Cerrar sesión',
  'common.reload': 'Recargar',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.kg': 'kg',

  'nav.home': 'Inicio',
  'nav.clients': 'Clientes',
  'nav.plans': 'Planes',
  'nav.analytics': 'Análisis',
  'nav.exercises': 'Ejercicios',
  'nav.profile': 'Perfil',
  'nav.profileMenu': 'Menú de perfil',

  'dash.logout': 'Cerrar sesión',
  'dash.logoutConfirmTitle': '¿Cerrar sesión?',
  'dash.logoutConfirmDesc': '¿Seguro que quieres salir?',
  'dash.switchToTrainer': 'Cambiar a entrenador',
  'dash.switchToClient': 'Cambiar a cliente',
  'dash.calendarWeek': 'Vista semanal',
  'dash.calendarBackToList': 'Volver al listado',
  'dash.refresh': 'Actualizar',
  'dash.refreshAria': 'Actualizar datos',

  'app.offlineSaved': 'Guardado sin conexión. Sincronizaremos cuando vuelva internet.',
  'app.telegramLoginFailed': 'No se pudo iniciar sesión con Telegram.',
  'app.telegramLoginHint':
    'Actualiza la página o entra con tu correo, como en la web.',
  'app.refresh': 'Recargar',
  'app.loginWithEmail': 'Entrar con correo',
  'app.loadContext': 'Cargando tu cuenta…',
  'app.loadInterface': 'Cargando la app…',
  'app.initializing': 'Cargando…',
  'app.contextError.default':
    'No pudimos cargar los datos. Revisa la conexión e inténtalo de nuevo.',
  'app.contextError.timeout': 'El servidor tardó demasiado. Revisa la red e inténtalo de nuevo.',
  'app.contextError.server': 'El servidor no está disponible ahora. Prueba más tarde.',
  'app.contextError.client': 'No pudimos cargar el perfil. Inténtalo de nuevo.',
  'app.noRole':
    'Esta cuenta no tiene rol de entrenador ni de cliente. Contacta con soporte.',
  'app.google.invalid_state': 'La sesión caducó. Vuelve a iniciar sesión.',
  'app.google.email_not_verified': 'Verifica tu correo en Google.',
  'app.google.account_conflict': 'Esta cuenta ya está vinculada a otro usuario de Google.',
  'app.google.not_configured': 'El inicio de sesión con Google está desactivado en el servidor.',
  'app.google.server_error': 'Error del servidor. Prueba más tarde.',
  'app.google.user_create_failed': 'No se pudo crear la cuenta.',
  'app.telegram.http': 'El servidor respondió {status}',
  'app.telegram.genericFail': 'No se pudo iniciar sesión con Telegram',
  'app.telegram.network': 'Sin red o petición bloqueada (CORS)',
  'app.google.unknown': 'Error de Google al iniciar sesión ({reason})',

  'profile.languageTitle': 'Idioma de la interfaz',
  'profile.lang.ru': 'Ruso',
  'profile.lang.en': 'Inglés',
  'profile.lang.es': 'Español',
  'profile.syncTitle': 'Sincronizar cuenta',
  'profile.syncTabGive': 'Mostrar código',
  'profile.syncTabTake': 'Introducir código',
  'profile.syncGiveIntro':
    'En el otro dispositivo abre «Introducir código» y escribe este ID de cuenta y el código.',
  'profile.syncAccountId': 'ID de cuenta',
  'profile.syncCodeLabel': 'Código de sincronización',
  'profile.syncCopyId': 'Copiar ID',
  'profile.syncCopyCode': 'Copiar código',
  'profile.syncGenerate': 'Generar código',
  'profile.syncTakeIntro':
    'Pega los datos de «Mostrar código» del otro dispositivo.',
  'profile.syncPlaceholderId': 'Introduce el ID de cuenta',
  'profile.syncPlaceholderCode': '000000',
  'profile.syncVerifying': 'Comprobando…',
  'profile.mergeTitle': 'Unir cuentas',
  'profile.mergeChoosePrimary': 'Elige qué cuenta será la principal',
  'profile.mergeCombineData': 'Combinar historial de entrenos, clientes y pagos',
  'profile.mergeConfirm': 'Confirmar',
  'profile.mergeCancel': 'Cancelar',
};
